import React from "react";
import Banner from "./components/Banner";
import bannerImg from "./assests/beach.png";

export default function Services() {
  return (
    <div>
      <Banner
        btype="image"
        src={bannerImg}
        heading="SERVICES"
        />
    </div>
  );
}
